import React from 'react';
import './InsightsBox.scss';
import CustomTooltip from '../../../../../shared/components/common/tooltip/CustomTooltip';
import EmptyPanel from '../../../../../shared/components/empty-panel/EmptyPanel';
import { t } from 'i18next';

interface InsightsBoxProps {
  hasAnyPendingQuestions: boolean;
  visibilityTexts: string[];
}

const InsightsBox: React.FC<InsightsBoxProps> = ({ hasAnyPendingQuestions, visibilityTexts }) => {
  return (
    <div className="insights-box-page stats__panel">
      <div className="page-box__title-action">
        <div className="page-box__title page-box__title--flex">
          {t('insights')}
          <CustomTooltip tooltipText="insightsTooltip" addMargin={false} />
        </div>
      </div>
      <div
        className={`stats-box stats-box--bar-chart  ${
          visibilityTexts && visibilityTexts.length === 1 ? 'insights-box--once' : ''
        } ${
          !hasAnyPendingQuestions && visibilityTexts.length === 0
            ? 'stats-box--empty'
            : 'stats-box--insights insights-box'
        }`}
      >
        {!hasAnyPendingQuestions && visibilityTexts.length === 0 ? (
          <EmptyPanel />
        ) : (
          visibilityTexts &&
          visibilityTexts
            .filter((text) => text.trim() !== '')
            .map((text, index) => (
              <div className="insights-box__row" key={`visibility-text-${index}`}>
                <div className="insights-box__ico-box">
                  <span className="ico--eye ico--md" />
                </div>
                <div
                  dangerouslySetInnerHTML={{
                    __html: text || '',
                  }}
                />
              </div>
            ))
        )}
      </div>
    </div>
  );
};

export default InsightsBox;
